import { reducerCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actionTypes } from '../actions/portaliPagineOfferte';


export const DEFAULT_STATE = helper.createDefaultState({
    list: { // todo: adattare alle specifiche delle pagine Offerte, il file attuale è preso da portaliPages.js
        filters: {
            portaleId: null,
            tipoPagina: null,
            localita: null,
            padre: null,
            offerte_start: null,
            offerte_end: null
        }
    }
});

const handlers = helper.createHandlers(actionTypes, {
    items: 'data.data',
    total: 'data.meta.total'
});

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

export const selectors = reducerCreator.createSelectors('portaliPagineOfferte');